import type { ReactNode } from "react";
import { FaceoffDot } from "./FaceoffDot";

export interface RedLineProps {
  /** Puts a red faceoff dot on the centre of the line. */
  centerDot?: boolean;
  className?: string;
  children?: ReactNode;
}

/** Full-width 3px red line: the horizon of a page or header. Decorative. */
export function RedLine({ centerDot = false, className = "" }: RedLineProps) {
  return (
    <div aria-hidden="true" className={`relative h-[3px] w-full bg-red ${className}`}>
      {centerDot ? (
        <FaceoffDot
          tone="red"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ring-4 ring-board"
        />
      ) : null}
    </div>
  );
}
